// frontend/src/lib/text/gradientTextLayout.js
//
// Single source of truth for laying out gradient-fill / gradient-stroke text in
// SVG. Used by BOTH CanvasEditor (the editor) and PageThumbnailPreview (the
// shared thumbnail/preview renderer) so they position gradient text identically.
//
// Layout is TOP-ANCHORED (Figma behaviour): the first baseline sits inside the
// first line box, NOT vertically centered within the element height. A previous
// PageThumbnailPreview bug centered it (baselineY = (height - totalH)/2 + fs),
// which made the thumbnail title drift vertically vs the editor.

/** @returns {{fs:number, lh:number, firstBaselineY:number, tx:number, anchor:string}} */
export function gradientTextLayout({ fontSize, lineHeight, width, textAlign } = {}) {
  const fs = Number(String(fontSize ?? 16).replace('px', '')) || 16;
  const lhNum = Number(lineHeight);
  const lh = Number.isFinite(lhNum) && lhNum > 0 ? lhNum * fs : fs * 1.25;
  const firstBaselineY = (lh - fs) / 2 + fs;
  const align = textAlign || 'left';
  const w = Number(width) || 0;
  const tx = align === 'center' ? w / 2 : align === 'right' ? w - 8 : 8;
  const anchor = align === 'center' ? 'middle' : align === 'right' ? 'end' : 'start';
  return { fs, lh, firstBaselineY, tx, anchor };
}

/** Absolute Y of line `i` (equivalent to a first tspan dy=firstBaselineY then dy=lh). */
export function gradientLineY(firstBaselineY, lh, i) {
  return firstBaselineY + i * lh;
}
